<template src="./template.html"></template>

<script>
  export default {
    name: 'ConfirmationOverlay',
    props: {
      isOpen: Boolean,
      object: Object,
    },
    computed: {
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.isOpen
        },
      },
    },
    methods: {
      onConfirmation() {
        this.$emit('onConfirmation')
      },
    },
  }
</script>
